import {
  InitClient,
  GetByParas,
  Post,
  PostWithParas
} from "../ZeusAPIClient.js";
import { apiConfig } from "../../config.js";
import { Predicate } from "../Model/Predicate.js";
InitClient(apiConfig.clientId, apiConfig.clientSecret, apiConfig.host);
//获取人员负责部门或者所在部门的销售业绩完成情况
async function GetSalesData(userCode, frameId) {
  var paras = { userCode: userCode, frameId: frameId };
  return await GetByParas("7e57a869-f2d7-48ed-8a79-0cd85a657857", paras);
}
//获取人员负责部门或者所在部门的销售业绩完成情况
async function GetServiceData(userCode, frameId) {
  var paras = { userCode: userCode, frameId: frameId };
  return await GetByParas("d70321fd-0112-4966-8b58-e052f2a19831", paras);
}
//获取子部门销售业绩完成情况
async function GetChildSalesData(frameId) {
  return await Post("84be8417-9fa8-476d-84d3-06f97ed1021c", frameId);
}
//获取子部门销售业绩完成情况
async function GetChildServiceData(frameId) {
  return await Post("2dbb99cb-404f-4808-a217-a730f99e84a7", frameId);
}
export { GetSalesData, GetServiceData, GetChildSalesData, GetChildServiceData };
